const routes = {
  education: {
    previous: null,
    next: 'design',
  },
  design: {
    previous: 'education',
    next: 'merch',
  },
  merch: {
    previous: 'design',
    next: 'team',
  },
  team: {
    previous: 'merch',
    next: 'partners',
  },
  partners: {
    previous: 'team',
    next: 'news',
  },
  news: {
    previous: 'partners',
    next: 'resources',
  },
  resources: {
    previous: 'news',
    next: null,
  },
  archive: {
    previous: null,
    next: null
  }
};

export default {
  methods: {
    handleScroll(event) {
      const currentRoute = this.$route;
      const currentRouteNavigation = routes[currentRoute.name];

      if (this.$store.state.screenSize > 1 && event.type === 'scroll') {
        return;
      }

      let tiles = this.$refs.tiles;

      if (typeof tiles === 'undefined') {
        return;
      }

      // Disable the 'scroll down' arrow
      if (currentRoute.name === 'resources' || currentRoute.name === 'archive') {
        if (tiles.scrollTop >= tiles.scrollHeight - tiles.offsetHeight - 5) {
          this.$bus.$emit('scroll-end', true);
        } else {
          this.$bus.$emit('scroll-end', false);
        }
      }

      if (this.off) return;

      if (tiles.getAttribute('data-tiles') !== currentRoute.name) return;

      if (
        currentRouteNavigation.next &&
        tiles.scrollTop >= tiles.scrollHeight - tiles.offsetHeight - 5 &&
        ((event.type === 'wheel' && event.deltaY > 50) || event.type === 'scroll')
      ) {
        // Next
        this.off = true;
        this.$router.push({ name: currentRouteNavigation.next });
      }

      if (
        currentRouteNavigation.previous &&
        this.$store.state.screenSize > 2 &&
        tiles.scrollTop === 0 &&
        ((event.type === 'wheel' && event.deltaY < -50) || event.type === 'scroll')
      ) {
        // Back
        this.off = true;
        this.$router.push({ name: currentRouteNavigation.previous });
      }
    },
  },
};
